import React from 'react';
import { Link } from 'react-router';

import Green from '../Images/green-circle.png';
import ManualRed from '../Images/manual-red.png';
import Red from '../Images/red-circle.png';
import ChapterGridAccordionLib from './ChapterGridAccordionLib';

function renderReferenceName(reference, rate, rolesPermissions, superAdmin) {
  if (
    !reference.actAsParent &&
    (superAdmin ||
      rolesPermissions.find(
        (permission) =>
          Number(permission.typeId) === rate &&
          permission.actions.find(
            (action) => action === 'Assignment.Publish',
          ) &&
          permission.actions.find((action) => action === 'Rates.References'),
      ))
  ) {
    return (
      <Link
        to={`/home/questions/${reference.id}/${reference.chapters[0].id}/${
          rate
        }`}
      >
        <span title={reference.name}>{reference.name}</span>
      </Link>
    );
  }
  return <span title={reference.name}>{reference.name}</span>;
}

export default class ReferencesGridAccordionLib {
  static getReferencesForGrid(
    references,
    chapters,
    functions,
    rate,
    rolesPermissions,
    superAdmin,
  ) {
    const formattedReferences = references.map((reference) => {
      let chaptersAux = [];
      if (reference.actAsParent) {
        chaptersAux = reference.chapters;
      }
      return {
        id: reference.id,
        name: renderReferenceName(
          reference,
          rate,
          rolesPermissions,
          superAdmin,
        ),
        subitems: this.getSubitems(reference, chapters),
        questions: this.getQuestionCount(reference),
        pdf: this.getPdfColumn(reference, functions.onDeletePdf),
        status: this.getStatusColumn(reference, functions.onStateClick),
        writer: this.getWriterColumnReference(reference),
        definitions: this.getDefinitionsColumn(
          reference,
          functions.onDefinitionsClick,
        ),
        chapters: chaptersAux,
        subtopicsIndicator: this.getSubtopicsIndicatorRef(reference),
        questionsIndicator: this.getQuestionsIndicatorRef(reference),
      };
    });
    return formattedReferences;
  }

  static getSubitems(reference, chapters) {
    if (reference.actAsParent) {
      const subitems = chapters.filter(
        (chapter) => chapter.reference === reference.id,
      );
      return subitems.length;
    }
    return 0;
  }

  static getQuestionCount(reference) {
    let questionsCount = 0;
    if (reference.chapters) {
      reference.chapters.map(
        (chapter) => (questionsCount += chapter.questionCount),
      );
    }
    return questionsCount;
  }

  static getPdfColumn(entity, onDeletePdf) {
    if (entity.pdfUrl !== '') {
      return (
        <div>
          <a href={entity.pdfUrl} target="_blank" rel="noreferrer">
            <i className="fa fa-file-pdf-o fa-lg mt-2" />
          </a>
          <i
            onClick={() => {
              onDeletePdf(entity);
            }}
            className="fa fa-trash fa-lg mt-2"
          />
        </div>
      );
    }
  }

  static getStatusColumn(reference, onStateClick) {
    if (reference.enabled) {
      return (
        <div
          className="statusLabel"
          onClick={() => {
            onStateClick(reference);
          }}
        >
          Active
        </div>
      );
    }
    return (
      <div
        className="statusLabel"
        onClick={() => {
          onStateClick(reference);
        }}
      >
        Disabled
      </div>
    );
  }

  static getWriterColumnReference(reference) {
    if (reference.actAsParent) {
      return '-';
    }
    return ChapterGridAccordionLib.writerColumnChapter(reference.chapters[0]);
  }

  static getDefinitionsColumn(reference, onDefinitionsClick) {
    return (
      <div
        className="statusLabel"
        onClick={() => {
          onDefinitionsClick(reference);
        }}
      >
        Definitions
      </div>
    );
  }

  static getSubtopicsIndicatorRef(reference) {
    const redIndicator = reference.chapters.find(
      (chap) =>
        chap.indicators.subtopics === 'red' ||
        chap.indicators.subtopics === 'forced',
    );
    if (
      redIndicator ||
      reference.chapters.length === 0 ||
      !reference.actAsParent
    ) {
      return <img alt="red" className="circleSize" src={Red} loading="lazy" />;
    }
    return (
      <img alt="green" className="circleSize" src={Green} loading="lazy" />
    );
  }

  static getQuestionsIndicatorRef(reference) {
    if (!reference.actAsParent) {
      const chapter = reference.chapters[0];
      if (chapter && chapter.indicators.questions === 'forced') {
        return (
          <img
            className="circleSizeManualRed"
            title={chapter.questionIndicatorReason}
            alt={chapter.questionIndicatorReason}
            src={ManualRed}
            loading="lazy"
          />
        );
      }
      if (chapter && chapter.indicators.questions === 'red') {
        return (
          <img alt="red" className="circleSize" src={Red} loading="lazy" />
        );
      }
      return (
        <img alt="green" className="circleSize" src={Green} loading="lazy" />
      );
    }
    const redIndicator = reference.chapters.find(
      (chap) =>
        chap.indicators.questions === 'red' ||
        chap.indicators.questions === 'forced',
    );
    if (redIndicator || reference.chapters.length === 0) {
      return <img alt="red" className="circleSize" src={Red} loading="lazy" />;
    }
    return (
      <img alt="green" className="circleSize" src={Green} loading="lazy" />
    );
  }
}
